exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper--10UyW {\n  height: calc(100vh - 62px);\n}\n\n.content--2BQon {\n  display: grid;\n  height: 100%;\n  grid-template-columns: 300px 1fr;\n  grid-template-rows: 50px 40px 27px calc(100% - 117px);\n  grid-template-areas: \"header header\" \"nav nav\" \"filters content-header\" \"filters content\";\n}\n\n.header--32SbX {\n  grid-area: header;\n  display: -ms-flexbox;\n  display: flex;\n  background: white;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 10px;\n  border-bottom: 1px solid silver;\n}\n\n.header--32SbX .separator--2tlun {\n  padding: 0 10px;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "wrapper--10UyW",
	"content": "content--2BQon",
	"header": "header--32SbX",
	"separator": "separator--2tlun"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/containers/Private/pages/workflow-processing/Page/Page.m.scss
// module id = 1488
// module chunks = 0